module.exports = function getPackages(packages = []) {
    return packages.map(pack => {
        return {
            id: pack.Id,
            licencePlate: pack.LicencePlate,
            grossWeight: pack.GrossWeight,
            volume: pack.Volume,
            goodsItemDescription: pack.GoodsItemDescription
        };
    });
};
